import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import CheckRadio from '../../common/forms/check-radio';
import InputField from '../../common/forms/input-field';

import { Gender, StepsCommonProps } from '../../types';

@inject('userInfoStore')
@observer
class StepBasicInfo extends React.Component<StepsCommonProps> {
  public render() {
    const store = this.props.userInfoStore!;
    return (
      <>
        <CheckRadio
            id="gender"
            label="Gender"
            layoutClassName="column is-12"
            name="gender"
            onChange={this.handleGenderChange}
            options={Object.values(Gender)}
            type="radio"
            value={store.gender}
        />

        <InputField
            label="City"
            layoutClassName="column is-8"
            name="city"
            onChange={this.handleCityChange}
            placeholder="e.g. San Francisco"
            type="text"
            value={store.city}
        />

        <InputField
            label="State"
            layoutClassName="column is-4"
            name="state"
            onChange={this.handleStateChange}
            placeholder="e.g. California"
            type="text"
            value={store.state}
        />

        <InputField
            label="Interests"
            layoutClassName="column is-12"
            name="interests"
            placeholder="Press &crarr; to add tags"
            onChange={this.handleInterestsChange}
            type="tags"
            value={store.interests.join(',')}
        />
      </>
    );
  }

  @action
  private handleInterestsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    if (value) {
      this.props.userInfoStore!.interests = value.split(',');
    }
  }

  /**
   * Sets proper state for city value change
   */
  @action
  private handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.userInfoStore!.city = event.currentTarget.value;
  }

  /**
   * Sets proper state for state value change
   */
  @action
  private handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.userInfoStore!.state = event.currentTarget.value;
  }

  /**
   * Sets proper state for gender radio button change
   */
  @action
  private handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const store = this.props.userInfoStore!;
    // Handle interests field separately
    switch (event.currentTarget.value) {
      case Gender.MALE:
        store.gender = Gender.MALE; break;
      case Gender.FEMALE:
        store.gender = Gender.FEMALE; break;
      default:
        store.gender = Gender.OTHER;
    }
  }
}

export default StepBasicInfo;



// WEBPACK FOOTER //
// ./src/pages/user-info/StepBasicInfo.tsx